<template>
	<!-- Searchable POS-product picker (phase 3: B40, active products only).
	     Emits `pick` with the chosen POS product row; the parent keeps its own
	     ordered list. -->
	<el-select
		v-model="picked"
		filterable
		remote
		clearable
		class="w-100"
		:remote-method="search"
		:loading="loading"
		:placeholder="$t('pos.product.picker')"
		@change="onPick"
		@focus="() => !options.length && search('')"
	>
		<el-option v-for="p in options" :key="p.id" :label="p.name" :value="p.id" :disabled="exclude.indexOf(p.id) !== -1">
			<span>{{ p.name }}</span>
			<span class="text-muted small ml-2">{{ p.code || "" }} · {{ money(p.price) }}</span>
		</el-option>
	</el-select>
</template>

<script>
import { Select, Option } from "element-ui";
import { PosService } from "@/resource";
import { posMoney } from "@/utils/pos";

export default {
	name: "PosProductPicker",
	components: { [Select.name]: Select, [Option.name]: Option },
	props: { exclude: { type: Array, default: () => [] } },
	data() {
		return { picked: null, options: [], loading: false };
	},
	methods: {
		money: posMoney,
		async search(q) {
			this.loading = true;
			try {
				const res = await PosService.posProductList({ status: 1, q: q || "" });
				this.options = (res.data && res.data.Data) || [];
			} catch (e) {
				this.options = [];
			} finally {
				this.loading = false;
			}
		},
		onPick(id) {
			const p = this.options.find((o) => o.id === id);
			if (p) this.$emit("pick", p);
			this.$nextTick(() => {
				this.picked = null;
			});
		}
	}
};
</script>
